export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "select_all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select All"])},
        "deselect_all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deselect All"])},
        "download_assets": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Download ", _interpolate(_named("count")), " assets selected as ZIP"])},
        "no_assets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No Assets selected"])}
      },
      "fr": {
        "select_all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout Sélectionner"])},
        "deselect_all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout Déselectionner"])},
        "download_assets": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Télécharger ", _interpolate(_named("count")), " actifs sélectionnés en tant que ZIP"])},
        "no_assets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun élément sélectionné"])}
      }
    }
  })
}